import { Component, inject } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import {
  BricksIconComponent,
  BricksModalBodyComponent,
  BricksModalComponent,
  BricksModalFooterComponent,
  BricksModalHeaderComponent,
} from '@enbw_bricks/ui'

@Component({
  selector: 'app-resource-deletion-confirmation',
  imports: [
    BricksModalComponent,
    BricksModalBodyComponent,
    BricksModalFooterComponent,
    BricksIconComponent,
    BricksModalHeaderComponent,
  ],
  templateUrl: './resource-deletion-confirmation.component.html',
  styleUrls: ['./resource-deletion-confirmation.component.scss', '../technical-resource-data.component.scss'],
})
export class ResourceDeletionConfirmationComponent {
  private readonly dialogRef = inject<MatDialogRef<ResourceDeletionConfirmationComponent>>(MatDialogRef)
  protected readonly data = inject(MAT_DIALOG_DATA)

  onConfirm() {
    this.dialogRef.close(true)
  }

  onCancel() {
    this.dialogRef.close(false)
  }
}
